import Navigation from '../Navigation/Navigation';

import placeholder from '../../Images/andy-marsh-music_color.jpeg';
// import placeholder from '../../Images/andymarsh_2.png';
import bleedingfingers from '../../Images/bleedingfingers.jpeg';

// const placeholder = 'https://images.pexels.com/photos/13085461/pexels-photo-13085461.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';

const About = ({navigate,dimensions,width}) => {

	let photoWidth = 400;
	if(width < 800) photoWidth = 300;

	if(width < 660){
		return(
			<div>
				<Navigation navigate={navigate} width={width} />
				<div style={{height:60}}></div>

				<div style={{height:30}}></div>
				

				<div style={{width:width,margin:'auto'}}>
					<div style={{width:width,height:photoWidth*1.5,overflow:'hidden',borderRadius:5}} className='flexCenterM'>
						<img src={placeholder} alt='placeholder' style={{width:'120%'}} />
					</div>
					<div style={{width:(photoWidth/10)}}></div>
					<div style={{height:10}}></div>
					<div className='heroText bold' style={{margin:'auto',width:width}}>Andy Marsh</div>
					<div style={{width:width,marginTop:10}} className='flexCenterX'>
						{/*<div className='subHeading bold'></div>*/}
						<div style={{marginTop:0}}>Los Angeles based composer and songwriter Andy Marsh has had his music featured in global television series, amassed millions of streams online, and has worked with some of the most influential artists, producers, studios, and composers in today’s music industry.</div>

						<div style={{marginTop:20}}>Andy worked for Hans Zimmer’s Bleeding Fingers Music for the past year and a half where he composed for a variety of projects.</div>

						<div style={{marginTop:20}}>Before joining this composing collective, Andy spent his time songwriting and producing for various brands, artists, and labels. He was first discovered back in 2013 by Miles Beard (previous President Of A&R at APG Studios) and has released some of his own music in the past few years (accumulating over +20 Million streams worldwide).</div>

						<div style={{marginTop:20}}>Working as both a songwriter and a composer has given Andy a unique advantage as a musician in today’s market. From being able to write a melody that is instantly recognizable, to working within tight deadline parameters, to collaborating and working with different project needs and visions, Andy’s music is dynamic, impactful, and memorable.</div>

					</div>
					<div className='flexCenter subHeading bold relative' style={{marginTop:30,zIndex:2}}>HANS ZIMMER’S</div>
					<div style={{marginTop:-24,zIndex:0}} className='flexCenter relative'>
						<img src={bleedingfingers} alt='bleedingfingers' style={{width:'100%'}} />
					</div>
				</div>
			</div>
		)
	}

	return(
		<div>
			<Navigation navigate={navigate} width={width} />
			<div style={{height:60}}></div>

			<div style={{height:30}}></div>
			<div className='heroText bold' style={{margin:'auto',width:width}}>Andy Marsh</div>
			<div style={{height:20}}></div>

			<div style={{width:width,margin:'auto'}} className='flexLeft'>
				<div style={{width:photoWidth,height:photoWidth*1.5,overflow:'hidden',borderRadius:5}} className='flexCenterX'>
					<img src={placeholder} alt='placeholder' style={{width:'120%'}} />
				</div>
				<div style={{width:(photoWidth/10)}}></div>
				<div style={{width:width-photoWidth-(photoWidth/10)}} className='flexCenterX'>
					{/*<div className='subHeading bold'></div>*/}
					<div style={{marginTop:0}}>Los Angeles based composer and songwriter Andy Marsh has had his music featured in global television series, amassed millions of streams online, and has worked with some of the most influential artists, producers, studios, and composers in today’s music industry.</div>

					<div style={{marginTop:20}}>Andy worked for Hans Zimmer’s Bleeding Fingers Music for the past year and a half where he composed for a variety of projects.</div>

					<div style={{marginTop:20}}>Before joining this composing collective, Andy spent his time songwriting and producing for various brands, artists, and labels. He was first discovered back in 2013 by Miles Beard (previous President Of A&R at APG Studios) and has released some of his own music in the past few years (accumulating over +20 Million streams worldwide).</div>

					<div style={{marginTop:20}}>Working as both a songwriter and a composer has given Andy a unique advantage as a musician in today’s market. From being able to write a melody that is instantly recognizable, to working within tight deadline parameters, to collaborating and working with different project needs and visions, Andy’s music is dynamic, impactful, and memorable.</div>
					<div className='flexCenter subHeading bold relative' style={{marginTop:30,zIndex:2}}>HANS ZIMMER’S</div>
					<div style={{marginTop:-24,zIndex:0}} className='flexCenter relative'>
						<img src={bleedingfingers} alt='bleedingfingers' style={{width:'100%'}} />
					</div>
				</div>
			</div>
		</div>
	)
}

export default About;